export function disposeAll() {
   if (FusionCharts && Object.keys(FusionCharts.items).length) {
      Object.keys(FusionCharts.items).forEach(chart => FusionCharts.items[chart].dispose());
   }
}

export default {
   disposeAll,
};
